import { Check } from "lucide-react";

const WhatYoullLearn: React.FC = () => {
  const learnings = [
    "How to set up Remotion in a Next.js project",
    "The Claude prompts I use to generate compositions",
    "Building animated text, charts, and product demos",
    "Timing, easing, and sequence structure explained simply",
    "How to render MP4s locally and in the cloud",
    "Reusable component patterns for social clips",
    "Common mistakes (and how to avoid them)",
    "My full workflow: idea → Claude → render → publish",
    "Templates you can copy and customize immediately",
    "Tips for iterating fast without breaking renders",
  ];

  return (
    <section className="bg-black text-white py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">
          What you'll learn
        </h2>

        <p className="text-xl text-cyan-400 font-semibold mb-8 text-center">
          A workflow you can copy right away:
        </p>

        <div className="grid md:grid-cols-2 gap-4 mb-8">
          {learnings.map((item, index) => (
            <div
              key={index}
              className="flex items-start space-x-3 bg-gray-900 p-4 rounded-lg"
            >
              <Check className="text-cyan-400 flex-shrink-0 mt-1" size={20} />
              <span className="text-gray-200">{item}</span>
            </div>
          ))}
        </div>

        <p className="text-center text-lg text-gray-300 font-medium">
          Everything inside is actionable. No fluff. No theory. Just what actually works today.
        </p>
      </div>
    </section>
  );
};

export default WhatYoullLearn;
